import { Paper } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";
import withStyles from "@material-ui/core/styles/withStyles";
import { instance } from "Actions/AxiosInstance";
import { DatePickerComponent } from "Component/Custom";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import SearchSq from "Component/Material-ui/SearchSq";
import { ErrorMessages } from "Constants";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
// import { getFormattedDate, getFormattedImageLink } from "../../Utils";
import { getEJ2CalenderDateFormat } from "Utils";
import {
  removeSaveProgress,
  setSaveProgress,
} from "../../../Actions/SaveProgressAction";

let mindate = null;

const objectiveDropdown = [
  {
    displayname: "Individual",
    displayvalue: 5,
  },
  {
    displayname: "Department",
    displayvalue: 2,
  },
  {
    displayname: "Team",
    displayvalue: 3,
  },
  {
    displayname: "Business Unit",
    displayvalue: 1,
  },
  {
    displayname: "Organization",
    displayvalue: 4,
  },
];

const frequencylist = [
  {
    displayname: "Q1",
    displayvalue: 1,
  },
  {
    displayname: "Q2",
    displayvalue: 2,
  },
  {
    displayname: "Q3",
    displayvalue: 3,
  },
  {
    displayname: "Q4",
    displayvalue: 4,
  },
];

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class CreateObjective extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      objectiveid: this.props.objectiveid,
      objectivetitle: this.props.objectivetitle,
      description: this.props.description,
      task:
        (this.props.objectiveid && this.props.task) ||
        this.props.tempTask ||
        [],
      measuretypeid: this.props.measuretypeid,
      currencyunicode: this.props.currencyunicode,
      currenydropdown: this.props.currenydropdown,
      objectiveunitid: this.props.objectiveunitid,
      otherdropdown: this.props.otherdropdown,
      targetvalue: this.props.targetvalue,
      searchValue: this.props.searchObjective || null,
      isobjectivedropdown: this.props.isobjectivedropdown,
      dropdownlist: this.props.dropdownlist,
      tempobjectivetypeid:
        (this.props.objectiveid && this.props.objectivetypeid) ||
        this.props.tempobjectivetypeid,
      parentobjectiveid: this.props.parentobjectiveid,
      parentobjectiveids: this.props.parentobjectiveids,
      WeightageType: this.props.WeightageType,
      weightagetypeid: this.props.weightagetypeid,
      typeid: this.props.typeid,
      objectivestatusid: this.props.objectivestatusid,
      objeciveResult: [],
      tempTask: this.props.tempTask,
      empList: this.props.empList,
      performcycle: this.props.performcycle,
      SelectedEmpData: this.props.SelectedEmpData,
      performcycledurationid: this.props.performcycledurationid,
      okrcycle: this.props.okrcycle,
      duedate: this.props.duedate,
      frequencytypeid: this.props.frequencytypeid,
      owneremployeeid: this.props.owneremployeeid,
    };
    this.handleChange1 = this.handleChange1.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.addTask = this.addTask.bind(this);
    this.getObjectiveTypeDropDown = this.getObjectiveTypeDropDown.bind(this);
    this.getObjectiveHeadName = this.getObjectiveHeadName.bind(this);
    this.searchHandler = this.searchHandler.bind(this);
    this.deleteTask = this.deleteTask.bind(this);
  }

  addTask() {
    const objTemp = {
      objectivetaskid: null,
      tasktitle: null,
      description: null,
    };

    this.state.task.push(objTemp);
    this.setState({
      // task
    });
  }

  searchHandler(event, isobjective = true) {
    const searcjQery = event ? event.target.value.toLowerCase() : null;
    if (searcjQery && searcjQery.length < 4) {
      instance
        .post("perform/getobjectivelist", {
          searchfor: searcjQery,
          objectivetypeid: event ? null : this.state.tempobjectivetypeid,
          employeeid: event
            ? null
            : this.state.tempobjectivetypeid == 5
            ? this.props.login.employeeid
            : null,
          periodtypeid: this.state.periodtypeid,
          frequencytypeid:
            this.state.frequencytypeid || this.state.tempfrequencytypeid,
          performcycledurationid:
            this.state.performcycledurationid ||
            this.state.tempperformcycledurationid,
        })
        .then((result) => {
          this.setState({
            dropdownlist: result.data.result,
            searchValue: searcjQery,
            backupList: result.data.result,
            isobjectivedropdown:
              result.data.result.length != 0 && isobjective ? true : false,
            open: isobjective
              ? false
              : result.data.result.length != 0
              ? true
              : false,
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else if (searcjQery == null || searcjQery == "") {
      instance
        .post("perform/getobjectivelist", {
          searchfor: searcjQery,
          objectivetypeid: event ? null : this.state.tempobjectivetypeid,
          employeeid: event
            ? null
            : this.state.tempobjectivetypeid == 5
            ? this.props.login.employeeid
            : null,
          periodtypeid: this.state.periodtypeid,
          frequencytypeid:
            this.state.frequencytypeid || this.state.tempfrequencytypeid,
          performcycledurationid:
            this.state.performcycledurationid ||
            this.state.tempperformcycledurationid,
        })
        .then((result) => {
          this.setState({
            dropdownlist: result.data.result,
            searchValue: searcjQery,
            open: result.data.result.length != 0 ? true : false,
            backupList: result.data.result,
            resultobjective:
              result.data.result.length != 0 ? this.state.resultobjective : [],
            parentobjectiveid: null,
            parentobjectiveids: null,
            originalobjectiveid: null,
            measuretypeid: 1,
            objectiveunitid: null,
            currencyunicode: null,
            frequencytypeid: null,
            performcycledurationid: null,
            periodtypeid: null,
            isdisable: false,
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.setState({
        searchValue: searcjQery,
      });
    }
  }

  componentDidMount() {
    if (this.state.typeid != null) {
      this.getObjectiveTypeDropDown();
      this.props.removeSaveProgress();
    }
  }

  handleChange1(key, value, optional = null, parentobjectivedetails = null) {
    const { detailsobjective, tempobjectivetask } = this.state;
    if (key == "task") {
      const { task } = this.state;
      task[optional].tasktitle = value;
      this.setState({
        task,
      });
    } else if (
      key === "objectivetask" &&
      detailsobjective[0].objectivetask[optional].taskstatusid != 4
    ) {
      detailsobjective[0].objectivetask[optional].taskstatusid = value;
      this.setState({
        detailsobjective,
      });
    } else if (key == "tempobjectivetask") {
      tempobjectivetask[optional].tasktitle = value;
      this.setState({
        tempobjectivetask,
      });
    } else if (key == "tempobjectivetypeid") {
      this.setState({
        tempobjectivetypeid: value,
      });
      this.getOtherData();
    } else if (key == "frequencytypeid") {
      this.setState({
        periodtypeid: 2,
        frequencytypeid: value,
      });
    } else if (key == "parentobjectiveid") {
      this.setState({
        parentobjectiveids: parentobjectivedetails.parentobjectiveids,
        measuretypeid: parentobjectivedetails.measuretypeid,
        objectiveunitid: parentobjectivedetails.objectiveunitid,
        currencyunicode: parentobjectivedetails.currencyunicode,
        frequencytypeid: parentobjectivedetails.frequencytypeid,
        performcycledurationid: parentobjectivedetails.performcycledurationid,
        periodtypeid: parentobjectivedetails.periodtypeid,
        isdisable: true,
        [key]: value,
        searchValue: optional,
        isobjectivedropdown: false,
      });
    } else if (key == "measuretypeid") {
      value = parseInt(value);
      if (value == 1) {
        this.setState({
          currencyunicode: null,
          [key]: value,
          objectiveunitid: null,
          targetvalue: 100,
        });
      }
      if (value == 2) {
        this.setState({
          [key]: value,
          objectiveunitid: null,
          // targetvalue: null,
        });
      }
      if (value == 3 && this.state.otherdropdown.length == 0) {
        this.props.enqueueSnackbar("Please create objective unit", {
          variant: "error",
        });
      }
      if (value == 3) {
        this.setState({
          currencyunicode: null,
          [key]: value,
          // targetvalue: null,
        });
      }
    } else {
      if (key == "duedate") {
        if (value.value) {
          const year = new Date(value.value).getFullYear();
          const month = new Date(value.value).getMonth() + 1; // getMonth is zero based;
          const day = new Date(value.value).getDate();
          value = [year, month, day].join("-");
        } else {
          value = null;
        }
        // value = value.getFullYear() + '-' + value.getMonth()+1 + '-' + value.getDate() ;
      }
      this.setState({
        [key]: value,
      });
    }
  }

  deleteTask(index) {
    const { task } = this.state;
    task.splice(index, 1);
    this.setState({
      task,
    });
  }

  onCreate() {
    const {
      objectiveid,
      originalobjectiveid,
      parentobjectiveid,
      objectivetitle,
      addobjective,
      description,
      tempTask,
      measuretypeid,
      weightagetypeid,
      tempobjectivetypeid,
      typeid,
      periodtypeid,
      frequencytypeid,
      duedate,
      owneremployeeid,
      publishtypeid,
      targetvalue,
      currencyunicode,
      objectiveunitid,
      objectivestatusid,
      iskeyresult,
      performcycledurationid,
      parentobjectiveids,
      task,
    } = this.state;

    mindate = duedate ? duedate : mindate;
    const tempTask1 = task.map((x) => {
      const item = {};
      item.tasktitle = x.tasktitle;
      item.description = x.description;
      item.objectivetaskid = x.objectivetaskid;
      return item;
    });

    const { issaveinprogress } = this.props.SaveInProgressReducer;
    if (this.state.objectivetitle == "" || this.state.objectivetitle == null) {
      this.props.enqueueSnackbar("Please enter objective title", {
        variant: "error",
      });
    }
    //  else if (this.state.description == "" || this.state.description == null) {
    //   this.props.enqueueSnackbar("Please describe the objective", {
    //     variant: "error",
    //   });
    // }
    //  else if (
    //   (this.state.task.length == 1 && this.state.task[0].tasktitle == null) ||
    //   this.state.task.length == 0
    // ) {
    //   this.props.enqueueSnackbar(" please add atleast one task", {
    //     variant: "error",
    //   });
    // }
    else if (
      this.state.measuretypeid == 3 &&
      this.state.objectiveunitid == null
    ) {
      this.props.enqueueSnackbar("Please select one of the unit type", {
        variant: "error",
      });
    } else if (
      this.state.measuretypeid == 2 &&
      this.state.currencyunicode == null
    ) {
      this.props.enqueueSnackbar("Please select one of the currency type", {
        variant: "error",
      });
    } else if (this.state.targetvalue == null) {
      this.props.enqueueSnackbar("Please enter the target", {
        variant: "error",
      });
    } else if (this.state.tempobjectivetypeid == null) {
      this.props.enqueueSnackbar("Please select objective type ", {
        variant: "error",
      });
    } else if (this.state.owneremployeeid == null) {
      this.props.enqueueSnackbar("Please select owner ", { variant: "error" });
    } else if (this.state.performcycledurationid == null) {
      this.props.enqueueSnackbar("Please select year", { variant: "error" });
    } else if (this.state.frequencytypeid == null) {
      this.props.enqueueSnackbar("Please select quarter", { variant: "error" });
    } else if (mindate == null) {
      this.props.enqueueSnackbar("Please select due date", {
        variant: "error",
      });
    } else if (!issaveinprogress) {
      this.props.setSaveProgress(true);
      instance
        .post("perform/createobjective", {
          objectiveid,
          parentobjectiveid:
            tempobjectivetypeid == 4 ? null : parentobjectiveid,
          originalobjectiveid:
            tempobjectivetypeid == 4 ? null : originalobjectiveid,
          objectivestatusid: objectiveid ? objectivestatusid : 1,
          objectivetitle,
          description,
          measuretypeid,
          weightagetypeid,
          objectivetypeid: tempobjectivetypeid,
          typeid,
          periodtypeid: 2,
          frequencytypeid,
          duedate: mindate,
          parentobjectiveids,
          owneremployeeid,
          publishtypeid: 1,
          targetvalue,
          currencyunicode,
          objectiveunitid,
          iskeyresult,
          task: tempTask1,
          performcycledurationid,
        })
        .then(() => {
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          const temptask = [
            {
              objectivetaskid: null,
              tasktitle: null,
              description: null,
            },
          ];
          // this.toggleDrawer("right", false)
          this.setState(
            {
              objectiveid: null,
              iskeyresult: true,
              parentobjectiveid: null,
              parentobjectiveids: null,
              originalobjectiveid: null,
              alignname: null,
              objectivetitle: null,
              description: null,
              measuretypeid: 1,
              weightagetypeid: 4,
              tempobjectivetypeid: null,
              typeid: null,
              periodtypeid: null,
              frequencytypeid: null,
              duedate: null,
              owneremployeeid: null,
              publishtypeid: 1,
              targetvalue: 100,
              currencyunicode: null,
              objectiveunitid: null,
              objectivestatusid: null,
              searchValue: null,
              task: [],
              right: false,
              ownerid: null,
            },
            () => {
              this.props.toggleDrawer("right", false);
              this.props.getOkrData(
                this.props.resultobjective[0]?.objectiveid == undefined
                  ? null
                  : this.props.resultobjective[0].objectiveid,
                false,
                null,
              );
            },
          );
        })
        .catch((error) => {
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  UpdateSelectedEmpId(selectedItem) {
    this.setState({
      owneremployeeid: selectedItem ? selectedItem.displayvalue : null,
      SelectedEmpData: selectedItem,
    });
    // this.UpdateSelectedEmpId = this.UpdateSelectedEmpId.bind(this);
  }

  getObjectiveTypeDropDown() {
    instance
      .get(`perform/getobjectivetypelist/${this.state.tempobjectivetypeid}`)
      .then((result) => {
        this.setState({
          objeciveResult: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getObjectiveHeadName(tempobjectivetypeid, typeid, employeeid = null) {
    instance
      .post(`perform/getobjectivetypehead`, {
        objectivetypeid: tempobjectivetypeid,
        typeid,
        employeeid,
      })
      .then((result) => {
        this.setState({
          owneremployeeid:
            result.data.result[0] && result.data.result[0].displayvalue,
          SelectedEmpData: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  render() {
    const findMax = () => {
      const { performcycle, performcycledurationid, frequencytypeid } =
        this.state;
      const max = performcycle.find(
        (x) => x.displayvalue == performcycledurationid,
      );
      let date;
      if (max && max.cyclestart) {
        date = moment(max.cyclestart).subtract(1, "days");
      }
      if (frequencytypeid != null) {
        return max
          ? moment(date)
              .add(3 * frequencytypeid, "M")
              .format("YYYY-MM-DD")
          : null;
      } else {
        return max ? date : null;
      }
    };

    const findMin = () => {
      const { performcycle, performcycledurationid, frequencytypeid } =
        this.state;
      const max = performcycle.find(
        (x) => x.displayvalue == performcycledurationid,
      );

      if (frequencytypeid != null) {
        mindate =
          max &&
          moment(max.cyclestart)
            .add(3 * (frequencytypeid - 1), "M")
            .format("YYYY-MM-DD");
        return max
          ? moment(max.cyclestart)
              .add(3 * (frequencytypeid - 1), "M")
              .format("YYYY-MM-DD")
          : null;
      } else {
        mindate = max && max.cyclestart;
        return max ? max.cyclestart : null;
      }
    };
    return (
      <div
        className="padding-bottom-16 thin-scroll"
        style={{ overflowY: "auto", height: "90vh", paddingRight: 8 }}
      >
        <p className="normal-dark-secondary margin-bottom-8">
          Type the objective you want to achieve below
        </p>
        <DynamicForm
          fields={textinputconverter({
            value: this.state.objectivetitle,
            label: "",
            placeholder: "Enter objective",
          })}
          onChange={(value) => {
            this.handleChange1("objectivetitle", value);
          }}
        />

        <p className="normal-dark-secondary margin-bottom-4">
          Explain the objective.
        </p>
        <div className="rounded-rectangle-div margin-bottom-24">
          <p className="extra-small-dark-secondary t-bold margin-bottom-8">
            Description
          </p>
          <DynamicForm
            fields={textareainputconverter({
              value: this.state.description,
              // label: "description",
              placeholder:
                "Describe the objective and give guidelines to guage success.",
            })}
            onChange={(value) => {
              this.handleChange1("description", value);
            }}
          />

          {/* <p className="extra-small-dark-secondary t-bold margin-bottom-8 ellipsis display-block">
            Tasks
          </p>

          <div>
            {this.state.task &&
              this.state.task.length != 0 &&
              this.state.task.map((x, index) => (
                // <div className="clear-float">
                <div className="position-rel margin-bottom-10">
                  <Input
                    placeholder="add new task"
                    inputProps={{ "aria-label": "description" }}
                    value={x.tasktitle}
                    isClearable={true}
                    style={{ width: "90%" }}
                    onChange={(event) => {
                      this.handleChange1("task", event.target.value, index);
                    }}
                  />

                  <span
                    onClick={() => this.deleteTask(index)}
                    className="cursour-pointer action-btn"
                    style={{ position: "absolute", right: 0 }}
                  >
                    <img src={deleteIcon} className="vertical-middle"></img>
                  </span>
                </div>
              ))}
          </div>
          <div className="cursor-pointer clear-both" onClick={this.addTask}>
            <Add
              style={{
                height: 16,
                width: 16,
                marginRight: 8,
                position: "relative",
                top: 3,
                borderRadius: 16,
                background: "#1E8CED",
                color: "#fff",
              }}
            />
            <span style={{ color: "#1E8CED", fontSize: 14 }}>Add Task</span>
          </div>
         */}
        </div>

        {/* <p className="normal-dark-secondary margin-bottom-4">
          How should the success be measured?
        </p>
        <div className="floatleft margin-right-16">
          <div style={{ width: 140 }}>
            <DynamicForm
              className="width100"
              fields={radioinputconverter({
                value: this.state.measuretypeid == 1,
                label: "Percentage",
                disabled: this.state.isdisable,
              })}
              onChange={() => this.handleChange1("measuretypeid", 1)}
            />
            <DynamicForm
              className="width100"
              fields={radioinputconverter({
                value: this.state.measuretypeid == 2,
                label: "Money",
                disabled: this.state.isdisable,
              })}
              onChange={() => this.handleChange1("measuretypeid", 2)}
            />
            <DynamicForm
              className="width100"
              fields={radioinputconverter({
                value: this.state.measuretypeid == 3,
                label: "Other units",
                disabled: this.state.isdisable,
              })}
              onChange={() => this.handleChange1("measuretypeid", 3)}
            />
          </div>
        </div>
        {this.state.measuretypeid == 2 && (
          <div
            style={{
              float: "right",
              position: "relative",
              top: 32,
              width: 208,
              zIndex: 1,
            }}
          >
            <DynamicForm
              fields={selectinputconverter({
                value: this.state.currencyunicode || null,
                placeholder: "Select currency",
                label: null,
                options: this.state.currenydropdown || [],
                disabled: this.state.isdisable,
              })}
              onChange={(value) => {
                this.handleChange1("currencyunicode", value);
              }}
            />
          </div>
        )}
        {this.state.measuretypeid == 3 && (
          <div
            style={{
              float: "right",
              position: "relative",
              top: 76,
              width: 208,
              zIndex: 1,
            }}
          >
            <DynamicForm
              fields={selectinputconverter({
                value: this.state.objectiveunitid || null,
                placeholder: "Select unit",
                label: null,
                options: this.state.otherdropdown || [],
                disabled: this.state.isdisable,
              })}
              onChange={(value) => {
                this.handleChange1("objectiveunitid", value);
              }}
            />
          </div>
        )}
        <div className="normal-dark-secondary margin-bottom-4">
          {this.state.measuretypeid != 1 ? (
            <DynamicForm
              fields={integerinputconverter({
                value: this.state.targetvalue,
                placeholder: "Enter the target value",
                label: "Target",
              })}
              onChange={(value) => {
                this.handleChange1("targetvalue", value);
              }}
            />
          ) : null}
        </div>
        <div className="clear-float"></div> */}

        {this.state.tempobjectivetypeid != 4 && (
          <div>
            <p className="normal-dark-secondary margin-bottom-4">
              If this objective aligns with another one, select here
            </p>
            <div className="objective-section">
              <SearchSq
                placeholder="Search for objective title, owner or type "
                value={this.state.searchValue}
                onChange={this.searchHandler}
              />
              {this.state.isobjectivedropdown && (
                <ClickAwayListener
                  onClickAway={() =>
                    this.setState({
                      isobjectivedropdown: false,
                      searchValue: null || "",
                    })
                  }
                >
                  <Paper
                    className="rounded-rectangle-paper thin-scroll"
                    style={{ maxHeight: 200, overflowY: "auto" }}
                  >
                    <List>
                      {this.state.isobjectivedropdown &&
                        this.state.dropdownlist.map((el) => (
                          <ListItemText
                            style={{
                              borderBottom: "1px solid #d8d8d8",
                              paddingLeft: 12,
                              paddingRight: 12,
                            }}
                            primary={el.displayname}
                            secondary={
                              <React.Fragment>
                                <div className="padding-bottom-16">
                                  <span className="small-dark-secondary floatleft margin-right-24">
                                    {el.typename}
                                  </span>
                                  {/* <span className="mall-dark-secondary floatleft">
                                        businessunit
                                    </span> */}
                                  <div className="clear-float"></div>
                                </div>
                              </React.Fragment>
                            }
                            onClick={() => {
                              this.handleChange1(
                                "parentobjectiveid",
                                el.displayvalue,
                                el.displayname,
                                el,
                              );
                            }}
                          />
                        ))}
                    </List>
                  </Paper>
                </ClickAwayListener>
              )}
            </div>
          </div>
        )}

        {/* <p className="normal-dark-secondary margin-bottom-4 margin-top-24">
          Goal's Importance
        </p>
        <div>
          {this.state.WeightageType.length != 0 &&
            this.state.WeightageType.map((x) =>
              x.displayvalue == this.state.weightagetypeid ? (
                <div
                  className=" goal-weightage goal-weightage-selected"
                  onClick={() =>
                    this.handleChange1("weightagetypeid", x.displayvalue)
                  }
                >
                  <span>{x.displayname}</span>
                </div>
              ) : (
                <div
                  className="goal-weightage"
                  onClick={() =>
                    this.handleChange1("weightagetypeid", x.displayvalue)
                  }
                >
                  <span>{x.displayname}</span>
                </div>
              ),
            )}

          <div className="clear-float"></div>
        </div> */}

        <p className="normal-dark-secondary margin-bottom-4 margin-top-16">
          Select individual or group
        </p>
        <div>
          <DynamicForm
            fields={selectinputconverter({
              value: this.state.tempobjectivetypeid || null,
              placeholder: "Select",
              label: null,
              options: objectiveDropdown || [],
            })}
            onChange={(value) => {
              this.setState(
                { objectivetypeid: value, tempobjectivetypeid: value },
                () => {
                  this.state.objectivetypeid == 4 ||
                  this.state.objectivetypeid == 5
                    ? this.getObjectiveHeadName(
                        this.state.objectivetypeid,
                        this.state.typeid,
                        this.props.login.employeeid,
                      )
                    : this.getObjectiveTypeDropDown();
                },
              );
            }}
          />
        </div>
        {this.state.tempobjectivetypeid != 4 &&
        this.state.tempobjectivetypeid != 5 &&
        this.state.tempobjectivetypeid != null ? (
          <div>
            {/* <p className="normal-dark-secondary margin-bottom-4 margin-top-16">
              Select Objective
            </p> */}
            <DynamicForm
              fields={selectinputconverter({
                value: this.state.typeid || null,
                placeholder:
                  this.state.tempobjectivetypeid == 1
                    ? "Select business unit"
                    : this.state.tempobjectivetypeid == 2
                    ? "Select department"
                    : "Select team",
                label: null,
                options: this.state.objeciveResult,
              })}
              onChange={(value) => {
                this.setState({ typeid: value }, () => {
                  this.getObjectiveHeadName(
                    this.state.tempobjectivetypeid,
                    this.state.typeid,
                  );
                });
              }}
            />{" "}
          </div>
        ) : (
          ``
        )}

        <p className="normal-dark-secondary margin-bottom-4 margin-top-8">
          Select owner for this objective
        </p>
        <Select
          className="selectsearch width100"
          onChange={this.UpdateSelectedEmpId.bind(this)}
          options={this.state.empList}
          getOptionLabel={(option) => option.displayname}
          getOptionValue={(option) => option.displayvalue}
          value={this.state.SelectedEmpData}
          placeholder="Select employee"
        />

        <div className="margin-top-16">
          <p className="normal-dark-secondary margin-bottom-4">Time period</p>
          <div className="width100">
            <DynamicForm
              fields={selectinputconverter({
                value: this.state.performcycledurationid,
                placeholder: "Select time period",
                options: this.state.okrcycle,
                disabled: this.state.isdisable,
              })}
              onChange={(value) =>
                this.handleChange1("performcycledurationid", value)
              }
            />
          </div>

          <p className="normal-dark-secondary margin-bottom-4">
            Select Quarter
          </p>
          <div className="width100">
            <DynamicForm
              fields={selectinputconverter({
                value: this.state.frequencytypeid,
                placeholder: "Select Quarter",
                options: frequencylist,
                disabled:
                  this.state.performcycledurationid == null
                    ? true
                    : this.state.isdisable
                    ? this.state.isdisable
                    : false,
              })}
              onChange={(value) => this.handleChange1("frequencytypeid", value)}
            />
          </div>
        </div>
        <div className="clear-float"></div>
        <div className="due-date-top">
          <p className="normal-dark-secondary margin-bottom-4">Due date</p>
          {this.state.performcycledurationid != null ? (
            <DatePickerComponent
              start="Month"
              depth="Month"
              format={getEJ2CalenderDateFormat()}
              min={findMin()}
              max={findMax()}
              value={this.state.duedate || findMin()}
              // allowEdit={false}
              onChange={(value) => {
                this.handleChange1("duedate", value);
              }}
              width={"100%"}
              isClearable={true}
            />
          ) : (
            <DatePickerComponent
              start="Decade"
              // depth="Year"
              format={getEJ2CalenderDateFormat()}
              min={findMin()}
              max={findMax()}
              value={this.state.duedate}
              allowEdit={false}
              onChange={(value) => {
                this.handleChange1("duedate", value);
              }}
              width={"100%"}
              isClearable={true}
            />
          )}
        </div>

        <div className="clear-float"></div>
        <div className="floatleft margin-right-16 margin-bottom-16 padding-top-16">
          <div className="margin-bottom-24">
            <Button
              variant="contained"
              className="btn btn-secondary-md-blue margin-right-16"
              color="primary"
              onClick={this.props.toggleDrawer("right", false)}
            >
              Cancel
            </Button>
            {this.state.objectiveid == null ? (
              <Button
                variant="contained"
                className="btn btn-primary-md-blue"
                color="primary"
                onClick={() => {
                  this.onCreate();
                }}
                disabled={this.props.SaveInProgressReducer.issaveinprogress}
              >
                Save
              </Button>
            ) : (
              <Button
                variant="contained"
                className="btn btn-primary-md-blue"
                color="primary"
                onClick={() => {
                  this.onCreate();
                }}
                disabled={this.props.SaveInProgressReducer.issaveinprogress}
              >
                Update
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SaveInProgressReducer: state.SaveInProgressReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  login: state.AuthenticationAction.login,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );

// const mapDispatchToProps = (dispatch) =>
//   bindActionCreators(
//     {
//       setPreview: setPreviewAction,
//     },
//     dispatch,
//   );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(CreateObjective)));
